module.exports = __webpack_public_path__ + "static/media/powered_by_laukti_logo_stack.29e80774.svg";